import { RVIcon, RVIconSizeOptions } from "@regal-voice/ui";
import { TextDOMPurify } from "Services/Sanitization";

import { highlightMatches } from "../helper";

import styles from "./SpotlightAiAgentsItem.module.scss";
type SpotlightAiAgentsItemProps = {
    name: string;
    description?: string;
    searchValue: string;
    onCallback: () => void;
    route?: string;
};

export function SpotlightAiAgentsItem({
    name,
    description,
    searchValue,
    onCallback,
    route,
}: SpotlightAiAgentsItemProps): JSX.Element {
    return (
        <div className={styles.spotlightItem} data-route={route} onClick={onCallback}>
            <div>
                <RVIcon icon={"ai-agents"} size={RVIconSizeOptions.SMALL} />
            </div>
            <div>
                <div className={styles.routeContainer}>
                    <div
                        className={styles.name}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: TextDOMPurify.sanitize(highlightMatches(name, searchValue).toString()),
                        }}
                    ></div>
                </div>
                {description && (
                    <div
                        className={styles.description}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: TextDOMPurify.sanitize(highlightMatches(description, searchValue)),
                        }}
                    ></div>
                )}
            </div>
        </div>
    );
}
